import React from 'react';
import BaseDashboard from '../../components/BaseDashboard';
import OutboundScheduleForm from '../components/OutboundScheduleForm';
import HistoryView from './HistoryView';
import MonthView from './MonthView';
import OutboundView from './OutboundView';

/**
 * Dashboard for outbound truck operations
 * Extends the BaseDashboard with outbound-specific configuration
 */
const OutboundDashboard = ({ initialView }) => {
  // Define view components mapping for the base dashboard
  const viewComponents = {
    month: (props) => <MonthView {...props} mode="outbound" />,
    shipping: OutboundView,
    history: (props) => <HistoryView {...props} mode="outbound" />
  };
  
  // Calculate dashboard stats specific to outbound trucks using correct DB schema status values
  // Status enum('Scheduled','Staged','Loaded','Shipped','Completed','Cancelled')
  const calculateStats = (truckData) => {
    return {
      scheduled: truckData.filter(truck =>
        truck.status === 'Scheduled'
      ).length,
      inProgress: truckData.filter(truck =>
        truck.status === 'Staged' || truck.status === 'Loaded'
      ).length,
      shipped: truckData.filter(truck =>
        truck.status === 'Shipped' || truck.status === 'Completed'
      ).length,
      lateShipments: truckData.filter(truck =>
        truck.status === 'Scheduled' &&
        new Date(truck.scheduled_at) < new Date()
      ).length
    };
  };
  
  // Calculate trucks needing attention
  const calculateAttentionCount = (truckData, stats) => {
    return stats.lateShipments;
  };

  return (
    <BaseDashboard
      initialView={initialView}
      mode="outbound"
      apiEndpoint="outbound-trucks"
      scheduleFormComponent={OutboundScheduleForm}
      viewComponents={viewComponents}
      calculateStats={calculateStats}
      calculateAttentionCount={calculateAttentionCount}
      socketEventName="outbound-truck-schedule-update"
    />
  );
};

export default OutboundDashboard;